module.exports = __webpack_public_path__ + "img/3.03867089.jpg";